module.exports = {
    DELETE_TASKBOARD: "Are you sure you want to delete this card?",
    DELETE_QATASKBOARD: "Are you sure you want to delete this card?",
    TESTED_QATASKBOARD: "Are you sure you want to mark this card as tested?",
    DELETE_CUSTOM_TASKBOARD: "Are you sure you want to delete this card?",
    DONE_CUSTOM_TASKBOARD: "Are you sure you want to done this card?",
    DELETE_CUSTOM_DEVELOPER: "Are you sure you want to delete this developer from the custom taskboard?",
    DELETE_AI_DEVELOPER: "Are you sure you want to delete this developer from the Ai taskboard?",
}